import { render, staticRenderFns } from "./MyPageManager.vue?vue&type=template&id=4e5319b2&xmlns%3Av-on=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml&"
import script from "./MyPageManager.vue?vue&type=script&lang=js&"
export * from "./MyPageManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports